
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"26","viewBox":"0 0 20 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.438 16.188A7.437 7.437 0 0110 23.625a7.437 7.437 0 01-7.438-7.438c0-.788.394-2.065 1.26-3.745.828-1.612 1.957-3.344 3.122-4.963A76.53 76.53 0 0110 3.525a76.468 76.468 0 013.056 3.954c1.165 1.619 2.294 3.35 3.122 4.963.866 1.68 1.26 2.957 1.26 3.745zm-17 0c0-4.01 5.511-11.118 8.166-14.308C9.446.868 10 .25 10 .25s.554.618 1.396 1.63c2.655 3.19 8.167 10.298 8.167 14.308 0 5.28-4.282 9.562-9.563 9.562-5.28 0-9.562-4.282-9.562-9.563zm14.874 1.062a1.062 1.062 0 10-2.124 0c0 1.174-.951 2.125-2.126 2.125a1.062 1.062 0 100 2.125 4.25 4.25 0 004.25-4.25z","fill":"currentColor"}})])
          )
        }
      }
    